module.exports = __webpack_public_path__ + "static/media/9.565ad4a3.jpeg";